import { motion } from "framer-motion";
import { ArrowRight } from "lucide-react";

const IMG = "/kentucky/life5.jpg";
const ease = [0.22, 1, 0.36, 1];

// CONCEPT 1 — "Editorial Maison": magazine/gallery, oversized serif, whitespace, hairlines.
export const Concept1 = () => {
  const cats = ["Rugs", "Saddle Pads", "Tack", "Grooming", "Apparel", "Dog"];
  return (
    <div className="bg-[#FFFAF4] text-[#08083a]">
      {/* slim maison bar */}
      <div className="border-b border-[#08083a]/12">
        <div className="container-site flex items-center justify-between py-4 text-[11px] uppercase tracking-[0.28em]">
          <span className="font-display text-base tracking-[0.12em] normal-case">Boomerang</span>
          <span className="hidden sm:block text-[#08083a]/55">Maison Kentucky</span>
          <span className="text-[#FE7D01]">Shipped Worldwide</span>
        </div>
      </div>

      <div className="container-site grid items-center gap-12 py-16 lg:grid-cols-12 lg:py-24">
        {/* type-led left */}
        <div className="lg:col-span-6">
          <motion.p initial={{ opacity: 0, y: 12 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }}
            transition={{ duration: 0.6, ease }}
            className="text-[11px] font-medium uppercase tracking-[0.3em] text-[#08083a]/55">
            Est. Belgium — Express Worldwide
          </motion.p>
          <motion.h1 initial={{ opacity: 0, y: 18 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }}
            transition={{ duration: 0.8, ease }}
            className="mt-5 font-display text-[13vw] leading-[0.92] tracking-[-0.01em] sm:text-[84px] lg:text-[96px]">
            The Kentucky<br />Collection
          </motion.h1>
          <motion.div initial={{ scaleX: 0 }} whileInView={{ scaleX: 1 }} viewport={{ once: true }}
            transition={{ duration: 0.7, delay: 0.2, ease }} style={{ transformOrigin: "left" }}
            className="mt-6 h-px w-28 bg-[#FE7D01]" />
          <motion.p initial={{ opacity: 0 }} whileInView={{ opacity: 1 }} viewport={{ once: true }}
            transition={{ duration: 0.8, delay: 0.25 }}
            className="mt-6 max-w-md text-[15px] leading-relaxed text-[#08083a]/70">
            Belgian-designed equestrian equipment, held in our Ireland &amp; EU ateliers and
            dispatched worldwide with express delivery — curated by Boomerang.ie.
          </motion.p>
          <motion.a href="#" initial={{ opacity: 0 }} whileInView={{ opacity: 1 }} viewport={{ once: true }}
            transition={{ duration: 0.8, delay: 0.35 }}
            className="group mt-8 inline-flex items-center gap-2 text-sm font-medium uppercase tracking-[0.16em]">
            Discover the collection
            <span className="relative inline-block h-px w-10 bg-[#08083a] transition-all duration-300 group-hover:w-16">
              <ArrowRight className="absolute -right-1 -top-2 h-4 w-4 text-[#FE7D01]" />
            </span>
          </motion.a>
        </div>

        {/* framed portrait right */}
        <motion.figure initial={{ opacity: 0, y: 24 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }}
          transition={{ duration: 0.9, ease }} className="lg:col-span-6">
          <div className="relative overflow-hidden">
            <motion.img src={IMG} alt="Kentucky Horsewear rider"
              initial={{ scale: 1.12 }} whileInView={{ scale: 1 }} viewport={{ once: true }}
              transition={{ duration: 1.6, ease }}
              className="aspect-[4/5] w-full object-cover" />
            <div className="pointer-events-none absolute inset-0 ring-1 ring-inset ring-[#08083a]/10" />
          </div>
          <figcaption className="mt-3 flex items-center justify-between text-[11px] uppercase tracking-[0.22em] text-[#08083a]/50">
            <span>Spring / Summer Lookbook</span><span>No. 01</span>
          </figcaption>
        </motion.figure>
      </div>

      {/* serif running index */}
      <div className="border-y border-[#08083a]/12">
        <div className="container-site flex flex-wrap items-center gap-x-8 gap-y-2 py-6">
          {cats.map((c, i) => (
            <span key={c} className="flex items-center gap-8">
              <a href="#" className="font-display text-2xl text-[#08083a]/85 transition-colors hover:text-[#FE7D01] sm:text-3xl">{c}</a>
              {i < cats.length - 1 && <span className="h-1 w-1 rounded-full bg-[#FE7D01]" />}
            </span>
          ))}
        </div>
      </div>
    </div>
  );
};
